export enum InsuranceOverrideType {
    None = 0,
    ArizonaLoan = 1,
    StructureValueCoverageOnly = 2,
    PocApprovedException = 3,
}
